const modules = {

  /*
  ==========================================================
  TRANSPORTATION
  ==========================================================
  */

  transportation: {

    name:
      "Transportation",

    description:
      "Manage reservations, dispatching, vehicles, drivers, routes, and transportation operations."

  },

  /*
  ==========================================================
  ADVENTURES
  ==========================================================
  */

  adventure: {

    name:
      "Adventure",

    description:
      "Manage tours, guides, schedules, activities, and adventure bookings."

  },

  /*
  ==========================================================
  RENTALS
  ==========================================================
  */

  rentals: {

    name:
      "Rentals",

    description:
      "Manage rental inventory, availability, reservations, returns, and customer rentals."

  },

  /*
  ==========================================================
  RESTAURANTS
  ==========================================================
  */

  restaurants: {

    name:
      "Restaurants",

    description:
      "Manage tables, reservations, menus, orders, and restaurant operations."

  },

  /*
  ==========================================================
  CLINICS
  ==========================================================
  */

  clinics: {

    name:
      "Clinics",

    description:
      "Manage appointments, patients, medical staff, and clinical services."

  },

  /*
  ==========================================================
  HOTELS
  ==========================================================
  */

  hotels: {

    name:
      "Hotels",

    description:
      "Manage rooms, reservations, guests, housekeeping, and hotel operations."

  }

};

export default modules;